export const endpoints = {
  searchFavourites: 'validFavourite/search',
  changeOwner: 'validFavourite/owner:replace',
  addOwner: 'validFavourite/owner:add',
  changeUserGroups: 'validFavourite:shareWithUserGroups',
  changeUsers: 'validFavourite:shareWithUsers',
  deleteFavourite: 'validFavourite',
  owner: 'validFavourite/owner/all/options',
  sharedWithUser: 'validFavourite/sharedWithUsers/all/options',
  favouriteType: 'validFavourite/type/all/options',
  reportType: 'validFavourite/reportType/all/options',
  sharedWithUserGroupFilter: 'validFavourite/usergroup/all/options',
  sharedWithUserGroupOptions: 'validFavourite/usergroup/options',
  sharedWithUsersOptions: 'validFavourite/sharedWithUsers/options'
};
